import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";
import { POSTER_FETCH_LIMIT } from "./slice";

export const getPostersByTenantId = createWrappedAsyncThunk(
  "posters/getPostersByTenantId",
  async ({ offset }) => {
    const { data } = await httpClient.get("posters", {
      params: {
        offset,
        limit: POSTER_FETCH_LIMIT,
      },
    });
    return { data };
  },
);

export const updatePosterKey = createWrappedAsyncThunk(
  "posters/updatePosterKey",
  async ({ poster_id }) => {
    return await httpClient.post(`update-file-key`, {
      poster_id,
    });
  },
);